export const MODULE_CLASS_NAME = 'UiBaseModule';

export enum ViewNames {
    SINGLE_NAV_LAYOUT_VIEW = 'kta20-single-nav-layout-view',
}

export enum NavHosts {
    MAIN_NAV = 'kta20-main-nav',
}

export const VIEW_DID_LOAD_EVENT_NAME:string='ionNavDidChange';
export const VIEW_WILL_LOAD_EVENT_NAME:string='ionNavWillChange';